import ja from './locales/ja.json';
import en from './locales/en.json';
import es from './locales/es.json';
import ko from './locales/ko.json';
import zh from './locales/zh.json';

export type Locale = 'ja' | 'en' | 'es' | 'ko' | 'zh';

export const defaultLocale: Locale = 'ja';

export const locales: Record<Locale, Record<string, unknown>> = {
  ja,
  en,
  es,
  ko,
  zh,
};

export const localeNames: Record<Locale, string> = {
  ja: '日本語',
  en: 'English',
  es: 'Español',
  ko: '한국어',
  zh: '中文',
};

type NestedKeyOf<T> = T extends object
  ? {
      [K in keyof T]: K extends string
        ? T[K] extends object
          ? `${K}.${NestedKeyOf<T[K]>}`
          : K
        : never;
    }[keyof T]
  : never;

export type TranslationKey = NestedKeyOf<typeof ja>;

export function getNestedValue(obj: Record<string, unknown>, path: string): string {
  const keys = path.split('.');
  let result: unknown = obj;

  for (const key of keys) {
    if (result && typeof result === 'object' && key in result) {
      result = (result as Record<string, unknown>)[key];
    } else {
      return path;
    }
  }

  return typeof result === 'string' ? result : path;
}

export function translate(
  locale: Locale,
  key: string,
  variables?: Record<string, string | number>
): string {
  let result = getNestedValue(locales[locale], key);

  if (variables) {
    Object.entries(variables).forEach(([varKey, varValue]) => {
      const placeholder = new RegExp(`\\{\\{\\s*${varKey}\\s*\\}\\}`, 'g');
      result = result.replace(placeholder, String(varValue));
    });
  }

  return result;
}
